import styled from "styled-components";
import { _ } from "@sablier/v2-mixins";
import type { ThemeType } from "@sablier/v2-themes";

const WrapperPartial = styled.div`
  ${(props) => props.theme.styles.row}
  & {
    gap: calc(${(props) => props.theme.sizes.edge} * 3 / 2);
    align-items: flex-start;
    width: 100%;
  }
`;

const Box = styled.div`
  ${(props) => props.theme.styles.row}
  & {
    position: relative;
    justify-content: center;
    width: 68px;
    height: 68px;
    border: 2px solid ${(props) => props.theme.colors.border};
    border-radius: 6px;
    background-color: ${(props) => props.theme.colors.dark100};

    &:after {
      position: absolute;
      content: "";
      z-index: ${(props) => props.theme.sizes.zIndexUnder};
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background-color: ${(props) => props.theme.colors.gray200};
      opacity: 0.4;
      filter: blur(20px);
    }
  }
`;

const Tint = styled.div<ITint>`
  ${(props) => props.theme.styles.row}
  & {
    position: relative;
    z-index: ${(props) => props.theme.sizes.zIndexOver};
    flex-shrink: 0;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: ${(props) => {
      return props.gradient
        ? props.theme.gradients[props.gradient]
        : props.theme.colors[props.color || "white"];
    }};

    &:after {
      position: absolute;
      content: "";
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background-color: ${(props) => props.theme.colors.dark300};
    }
  }
`;

const Content = styled.div`
  ${(props) => props.theme.styles.column}
  & {
    flex: 1;
    row-gap: 6px;
    &:empty {
      display: none;
    }
  }
`;

const Title = styled.div`
  ${(props) => props.theme.styles.row}
  & {
    color: ${(props) => props.theme.colors.gray200};
    & > p {
      ${(props) => props.theme.styles.textElement}
    }
  }
`;

const Description = styled.div`
  color: ${(props) => props.theme.colors.gray400};

  & > p {
    ${(props) => props.theme.styles.textParagraph}
  }
`;

interface ITint {
  color?: keyof ThemeType["colors"];
  gradient?: keyof ThemeType["gradients"];
}

interface Props extends ITint {
  description: string;
  title: string;
}

const Wrapper = styled(WrapperPartial)`
  ${(props) => props.theme.medias.maxMD} {
    ${Content} {
      gap: calc(${(props) => props.theme.sizes.edge} * 1 / 2);
    }
  }
`;

function Item({ color, description, gradient, title }: Props) {
  return (
    <Wrapper>
      <Box>
        <Tint color={color} gradient={gradient} />
      </Box>
      <Content>
        <Title>
          <p>{title}</p>
        </Title>
        <Description>
          <p>{description}</p>
        </Description>
      </Content>
    </Wrapper>
  );
}

export default Item;
